import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement, ReactNode } from 'react';
import { tokens } from '@synergy/theme-palo';

/**
 * A line of explanation inside a PALO form section — the sentence that says
 * what the switches below it do. Body copy, not a heading: the masks used to
 * drop it into a bare `Grid` and it came out at the size of a field label.
 * `<b>…</b>` in the text sets the part that must not be overlooked in bold.
 */
export const PaloSectionText = ({ id }: { id: string }): ReactElement => (
    <Box sx={{ fontSize: '12.5px', lineHeight: '18px', color: tokens.color.ink2 }}>
        <FormattedMessage id={id} values={{ b: (chunks: ReactNode) => <strong>{chunks}</strong> }} />
    </Box>
);
